import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplierRoundListService, TranslationManager, Auth, SupplierRoundSelectedOffer } from 'src/common';

@Component({
  selector: 'confirmed-procurements',
  templateUrl: './confirmed-procurements.component.html'
})
export class ConfirmedProcurementsComponent implements OnInit {

  requestRoundSupplierId: number;
  items: SupplierRoundSelectedOffer[];
  translationManager = TranslationManager;
  auth = Auth;

  constructor(private route: ActivatedRoute, private supplierRoundListService: SupplierRoundListService, private location: Location) {}

  ngOnInit(): void {
    this.requestRoundSupplierId = +this.route.snapshot.params['requestRoundSupplierId'];
    this.getSupplierRoundSelectedOffers(this.requestRoundSupplierId);
  }

  getSupplierRoundSelectedOffers(id: number): void {
    this.supplierRoundListService.getSupplierRoundSelectedOffers(id).then(items => {
      this.items = items;
    });
  }
  navigateToBack() {
    this.location.back();
  }
}

// select * from supplierRoundSelectedOfferView
// where RequestRoundSupplierId = 1864

// select * from  RequestTicketItemSelectedOffer
// where RequestRoundSupplierId = 1864